<div class="modal-header bg-primary">
    <h4 class="modal-title"><b style="color: white;">{{cModalTitle}}</b></h4>
  </div>
  <div class="modal-body">
    <p>{{cModalBody}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="activeModal.close('OK')">OK</button>
  </div>